import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "42.668",
  viewBox: "0 0 42.668 50",
  fill: "#1aa",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M14.886 25.092L0 .812v48.93"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: "0.8",
    d: "M15.402 24.724h27.266L.258 0"
  }), /*#__PURE__*/_jsx("path", {
    fillOpacity: "0.6",
    d: "M15.402 25.46L.59 50l42.078-24.54"
  })]
});